import { NewOrdersSubheaderWrapper } from "../NewOrders.styles";
import { SearchItemText, SomethingDontLookRightText } from "constants/text";
import { SyntheticEvent, useEffect } from "react";
import SaveDraft from "../SaveDraft/SaveDraft";
import SuggestedSearch from "components/Common/SuggestedSearch/SuggestedSearch";
import { useSelector } from "react-redux";
import { RootState } from "stores/application.store";
import { ContactCare, DraftErrorTitle, ImportItems } from "../constants";
import AddGlobalAttributes from "../AddGlobalAttributes/AddGlobalAttributes";
import GlobalFormProvider from "../AddGlobalAttributes/forms/GlobalFormProvider";
import { models } from "types/api/viewModels.ts";
import { DialogTracking } from "components/Dialog/components/DialogTracking.ts";
import { Button } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import ErrorBanner from "../../Common/ErrorBanner/ErrorBanner.tsx";
import { APIErrorResponse, UntransformedResponse } from "features/api/utils/apiUtils.ts";
import { useDialog } from "hooks/useDialog.ts";
import { useUserLocation } from "hooks/useUserLocation.ts";

interface NewOrdersSubheaderProps {
	title: string;
	dataTestId: string;
	hasSearch?: boolean;
	handleSearch: (event: SyntheticEvent, values: string | null) => void;
	searchOptions?: Array<string>;
	searchValue?: string;
	autoCompleteId?: string;
	isLoading?: boolean;
	draftOrder: models["DraftOrderViewModel"] | undefined;
	hasAddGlobalAttributesButton?: boolean;
	isAddOn?: boolean;
}

const handleErrorMessaging = (error: UntransformedResponse<APIErrorResponse>) => {
	return (
		<div>
			<div>{DraftErrorTitle}</div>
			<div>{SomethingDontLookRightText}</div>
			<ul>
				{error?.data?.errors?.map((error: any, index: any) => (
					<li key={error.status + index}>{error.message}</li>
				))}
			</ul>
			<div>{ContactCare}</div>
			<div>({error?.status})</div>
		</div>
	);
};

const NewOrdersSubheader = ({
	title,
	dataTestId,
	hasSearch = false,
	handleSearch,
	isLoading,
	searchOptions,
	searchValue,
	autoCompleteId,
	draftOrder,
	hasAddGlobalAttributesButton = false,
	isAddOn = false
}: NewOrdersSubheaderProps) => {
	const { isCustomColorPage: isCustomColor } = useUserLocation();
	const isDraftError = useSelector((state: RootState) => state.newOrder.draftDetails?.draftError);
	const { isBuildOrderPage, isReviewOrderPage } = useUserLocation();
	const { openDialog, closeDialog } = useDialog();

	const handleImport = () => {
		openDialog({ dialogStatus: DialogTracking.CSV_UPLOAD });
	};

	useEffect(() => {
		if (!isReviewOrderPage) closeDialog();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div>
			<NewOrdersSubheaderWrapper
				isLoading={isLoading}
				data-testid={dataTestId}
			>
				<div>
					<h1>{title}</h1>
					<div>
						{hasAddGlobalAttributesButton && (
							<GlobalFormProvider>
								<AddGlobalAttributes
									isAddOn={isAddOn}
									isCustomColor={isCustomColor}
								/>
							</GlobalFormProvider>
						)}
						{isBuildOrderPage && (
							<Button
								variant="text"
								onClick={handleImport}
							>
								<UploadIcon />
								{ImportItems}
							</Button>
						)}

						<SaveDraft
							draftOrder={draftOrder}
							isAddOn={isAddOn}
							isCustomColor={isCustomColor}
						/>
						{hasSearch && (
							<div>
								<SuggestedSearch
									ariaLabel={autoCompleteId ?? ""}
									dataTestId={autoCompleteId ?? ""}
									dropDownOpenOnChar={3}
									placeholder={SearchItemText}
									handleSearch={handleSearch}
									id={autoCompleteId ?? ""}
									searchOptions={searchOptions ?? []}
									searchValue={searchValue ?? ""}
									size="small"
								/>
							</div>
						)}
					</div>
				</div>
			</NewOrdersSubheaderWrapper>
			{isDraftError && <ErrorBanner errorMessaging={handleErrorMessaging(isDraftError)} />}
		</div>
	);
};

export default NewOrdersSubheader;
